import React from 'react';

import BobPage from '../../../components/BobPage';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import Navigation from '../Navigation/Navigation';
import TableContainer from './TableContainer';

import * as classes from './EntitiesPage.module.css';

const EntitiesPage = ({
    children,
    ...props
}) => {

    return (
        <BobPage>
            <div className={classes.CompanyPage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={classes.HeaderPanel}>
                    <div className={classes.NavigationPanel}>
                        <Navigation />
                    </div>
                </div>
                <div className={classes.TitlePanel}>
                    Entity Management
                </div>
                <div className={classes.TablePanel}>
                    <TableContainer />
                </div>
            </div>
        </BobPage>
    );
};

export default EntitiesPage;
